import { render, staticRenderFns } from "./narasumber.vue?vue&type=template&id=2da5085c"
import script from "./narasumber.vue?vue&type=script&lang=js"
export * from "./narasumber.vue?vue&type=script&lang=js"
import style0 from "./narasumber.vue?vue&type=style&index=0&id=2da5085c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports